navigator?.serviceWorker?.getRegistrations()?.then(registrations => {
  for (const registration of registrations) {
    registration.unregister();
  }
});

import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './store'
import { Authenticator } from '@aws-amplify/ui-react'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'

const ENABLE_CLARITY = false

const initClarity = () => {
  const clarityWindow = window as Window & {
    clarity?: { (...args: any[]): void; q?: any[] }
  }
  ;((c: Window & { clarity?: { (...args: any[]): void; q?: any[] } }, l: Document, a: 'clarity', r: 'script', i: string) => {
    c[a] =
      c[a] ||
      function (...args: any[]) {
        ;(c[a]!.q = c[a]!.q || []).push(args)
      }
    const t = l.createElement(r)
    t.async = true
    t.src = `https://www.clarity.ms/tag/${i}`
    const y = l.getElementsByTagName(r)[0]
    y.parentNode?.insertBefore(t, y)
  })(clarityWindow, document, 'clarity', 'script', 'xj6pztnaen')
}

if (ENABLE_CLARITY) {
  initClarity()
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Suspense fallback='Loading...'>
    <Provider store={store}>
      <Authenticator.Provider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </Authenticator.Provider>
    </Provider>
  </Suspense>,
)
